import React, { useState, useEffect, useCallback } from 'react';
import { PhotoUploadMessage as PhotoUploadMessageType } from '@goodrx/heydoctor-sdk/es/models/message';
import { Placeholder, Text, styled, Flex } from '@goodrx/matisse';
import heydoctor from 'app/vendor/heydoctor';
import { MessageProps } from 'app/components/widgets/chat/message-types';
import { MessageSignature } from '../DefaultMessage/MessageSignature';
import { MessageRow } from '../DefaultMessage';
import * as Sentry from '@sentry/browser';

const PhotoBody = styled.div`
  border-radius: ${(p) => p.theme.radius}px;
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  height: 200px;
  overflow: hidden;
  width: 200px;
`;

const Image = styled.img`
  border-radius: ${(p) => p.theme.radius}px;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
`;

interface PhotoUploadMessageProps extends MessageProps {
  message: PhotoUploadMessageType;
}

export const PhotoUploadMessage: React.FC<PhotoUploadMessageProps> = ({ message }) => {
  const [imageSrc, setImageSrc] = useState<string>();
  const [isLoading, setLoading] = useState(false);

  const loadPhoto = useCallback(async () => {
    if (message.fileId) {
      setLoading(true);
      try {
        const data = await heydoctor.files.fetch(message.fileId);
        setImageSrc(data);
      } catch (e) {
        Sentry.captureException(e);
      } finally {
        setLoading(false);
      }
    }
  }, [message.fileId]);

  useEffect(() => {
    loadPhoto();
  }, [loadPhoto]);

  return (
    <MessageRow fromCurrentUser={true} flexDirection="column" alignItems="flex-end">
      <MessageSignature message={message} fromCurrentUser={true} />
      <PhotoBody>
        <Placeholder loading={isLoading}>
          {imageSrc ? (
            <Image data-qa="message_photo" src={imageSrc} />
          ) : (
            <Flex justifyContent="center" alignItems="center" height="100%">
              <Text>Image failed to load</Text>
            </Flex>
          )}
        </Placeholder>
      </PhotoBody>
    </MessageRow>
  );
};
